import { useAssignPermissionsToRoleMutation, Permission } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useAssignPermissionsHandler() {
	const [ assignPermissions ] = useAssignPermissionsToRoleMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( role: { id: number }, permissions: Permission[] ) => {
		const roleId = role.id
		const result = await assignPermissions( { variables: { roleId, permissions } } )

		if ( result.data?.assignPermissionsToRole?.success ) {
			showSuccess( `assignPermissionsToRoleSuccess${Date.now()}`, result.data?.assignPermissionsToRole?.message ?? 'Successfully assigned permissions!' )
		} else {
			showError( `assignPermissionsToRoleError${Date.now()}`, result.data?.assignPermissionsToRole?.message ?? 'Sorry, an error occurred' )
		}
	}
}
